import axios from "axios";
axios.defaults.baseURL = "https://plant-optimization-api-stage.azurewebsites.net/api/";
